import { BillByCounterpartySortValue } from "@common/types/bill";
import {
    useWorkspaceUserCache,
    WORKSPACE_USER_CACHE_KEYS,
} from "../useWorkspaceUserCache";

export function useBillsByCounterpartyPageSortingCache(): [
    BillByCounterpartySortValue | undefined,
    (value: BillByCounterpartySortValue | undefined) => void,
] {
    const [value, setter] = useWorkspaceUserCache<BillByCounterpartySortValue>(
        WORKSPACE_USER_CACHE_KEYS.BILLS_BY_COUNTERPARTY_PAGE_SORTING_CACHE_KEY,
    );

    return [
        value,
        (sorting: BillByCounterpartySortValue | undefined) => {
            setter(sorting);
        },
    ];
}
